/* eslint-disable react-hooks/refs */
import { useCallback, useRef } from "react";
import { useQuery } from "urql";
import { ProjectListAndStatusesQry } from "api/queries";

export const useProjectListQuery = ({ variables, pause = false }) => {
  const [{ data, error, fetching, stale }, refetch] = useQuery({
    query: ProjectListAndStatusesQry,
    variables,
    pause,
  });
  const { projectStatuses, currentUser } = data || {};
  const { projectList } = currentUser || {};

  const projectsCount = projectList?.overallStatistics
    ? Number(projectList.overallStatistics?.shared) +
      Number(projectList.overallStatistics?.notShared)
    : 0;

  const pagesCount = projectList?.pages || 0;

  const isLoading = fetching || stale;

  const getStatusColors = useCallback(
    (statuses) => {
      if (statuses) {
        return projectStatuses.reduce((result, current) => {
          result[current.status] = current.color;
          return result;
        }, {});
      }
      return {};
    },
    [projectStatuses],
  );

  const persistedDataRef = useRef(null);
  if (!isLoading && !error) {
    persistedDataRef.current = {
      projectsCount: projectsCount || 0,
      pagesCount: pagesCount || 0,
      filteredCount: projectList?.projectsCount || 0,
      statistics: projectList?.statistics || {},
      overallStatistics: projectList?.overallStatistics,
    };
  }
  const statusColorsRef = useRef(null);
  if (projectStatuses && !statusColorsRef.current) {
    statusColorsRef.current = getStatusColors(projectStatuses);
  }

  if (error) {
    console.error("useProjectList error: ", error);
  }

  return {
    data: {
      overallStatistics: persistedDataRef.current?.overallStatistics,
      statistics: persistedDataRef.current?.statistics,
      projectsCount: persistedDataRef.current?.projectsCount,
      pagesCount: persistedDataRef.current?.pagesCount,
      statusColors: statusColorsRef.current,
      filteredCount: persistedDataRef.current?.filteredCount,
      projects: projectList?.items || [],
      projectStatuses,
    },
    isLoading: fetching || stale,
    error,
    refetch,
  };
};
